import React, {Component} from 'react'
import { withRouter} from 'react-router-dom'
import { setUserInfo} from "../../../redux/common/action";
import { connect} from 'react-redux'
import { bindActionCreators, compose} from 'redux'
import '../index.scss'
import { Button, message} from 'antd'
import { getnum } from "@/servers/commonApi";



class Count extends Component{
    constructor(props) {
        super(props);
        this.run = this.run.bind(this);
        this.timer = this.timer.bind(this);
        this.stop = this.stop.bind(this);
        this.getphonenum = this.getphonenum.bind(this);
    }


    state = {
        time:0,
        disabled:false,
        t:null
    };

    //切换登录方式
    async run(){
        await this.setState((state, props) => ({
            time: props.seconds,
            disabled: true
        }));
        await this.timer();
    }

    //获取验证码
    async timer(){
        if (this.state.time>1){
            const num = --this.state.time
            await this.setState({
                time: num,
            })
            this.setState({
                t:await setTimeout(this.timer,1000)
            })
        }
        else{
            await clearTimeout(this.state.t);
            await this.stop();
        }
    }

    async stop(){
        await this.setState({
            time:0,
            disabled: false
        })
    }

    //获取验证码
    async getphonenum(){
        if(!this.props.mobile){
            message.error('请输入登录的手机号码');
            return
        }
        const reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!reg.test(this.props.mobile)) {
            message.error('请输入正确的手机号码');
            return
        }
        await getnum({mobile:this.props.mobile}).then(res=>{
          if(res.statecode === 0) {
            message.success('发送成功');
            this.run();
          } else {
            message.error(res.statemessage);
          }
        })
    }

    componentDidMount(){

    }

    componentWillUnmount(){
        clearTimeout(this.state.t);
         this.stop();
    }

    render(){
        return (
            <div className="grid-content getyzm">
                <Button
                    className='login-button'
                    block
                    type='text'
                    disabled={this.state.disabled}
                    onClick={()=>this.getphonenum()}
                >{this.state.time > 0 ? `${this.state.time}s再获取` : '获取验证码' }</Button>
            </div>
        )
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        setUserInfo: bindActionCreators(setUserInfo, dispatch),
    }
};

export default compose(withRouter, connect(mapDispatchToProps))(Count);
